import { render, staticRenderFns } from "./TabOrigem.vue?vue&type=template&id=0424ff30&"
import script from "./TabOrigem.vue?vue&type=script&lang=js&"
export * from "./TabOrigem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports